import { render, staticRenderFns } from "./WhatWeTeach.vue?vue&type=template&id=288fcd09&scoped=true"
import script from "./WhatWeTeach.vue?vue&type=script&lang=js"
export * from "./WhatWeTeach.vue?vue&type=script&lang=js"
import style0 from "./WhatWeTeach.vue?vue&type=style&index=0&id=288fcd09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288fcd09",
  null
  
)

export default component.exports